import { PROJECT_CODE_CONFIRMED_ACTION, PROJECT_CODE_FAILED_ACTION, PROJECT_CODE_ONEMP_ACTION, PROJECT_CODE_ONEMP_FAILED_ACTION } from "../actions/actionTypes";


const initialState = {
    list: [],
    data: {},
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function ProjectCodeReducer(state = initialState, action) {
    if (action.type === PROJECT_CODE_CONFIRMED_ACTION) {
        return {
            ...state,
            list: action.payload,
            errorMessage: '',
            successMessage: 'project codes fetched successfully',
            showLoading: false,
        };
    } else if (action.type === PROJECT_CODE_ONEMP_ACTION) {
        return {
            ...state,
            list: action.payload,
            errorMessage: '',
            successMessage: 'project codes of emp fetched successfully',
            showLoading: false,
        };
    }  else if (
        action.type === PROJECT_CODE_FAILED_ACTION ||
        action.type === PROJECT_CODE_ONEMP_FAILED_ACTION
    ) {

        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    } else {
        return state;
    }
}
